import { render, staticRenderFns } from "./api-documentation.vue?vue&type=template&id=060928a2&"
import script from "./api-documentation.vue?vue&type=script&lang=js&"
export * from "./api-documentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports